import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Dropdown, Input, Menu, Modal } from "antd";
import search from "../assets/search.svg";
import cDropdown from "../assets/cohort-dropdown.svg";
import { getInitials } from "../utils/stringHelpers";
import QalortButton from "./Button";
import clsx from "clsx";
import { GetCohortAttendees } from "../services/cohortService";
import { useMyCohorts } from "../hooks/useMyCohorts";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import BaseInput from "./BaseInput";
import SearchCohortsModal from "./cohorts/SearchCohortsModal";
import CohortTimeFilter from "./cohorts/cohort-time-filter";

const CohortList = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [searchQuery, setSearchQuery] = useState("");
  const [whatList, setWhatList] = useState("Created");
  const [openSearchModal, setOpenSearchModal] = useState(false);
  const { data: cohorts = [], isLoading: loading } = useMyCohorts();
  const qalortUser = useSelector((state) => state.user.userData);
  console.log(
    "cohorts",
    cohorts.filter((cohort) => cohort.slug === "introduction-to-python-26fed")
  );

  const filteredCohorts = useMemo(() => {
    let searchResult = [];
    if (searchQuery) {
      searchResult = cohorts.filter((cohort) =>
        cohort.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
    } else {
      searchResult = cohorts;
    }
    return qalortUser?.user_type === "learner"
      ? searchResult
      : whatList === "Created"
      ? searchResult.filter((cohort) => cohort?.user_id === qalortUser?.id)
      : searchResult.filter((cohort) => cohort?.user_id !== qalortUser?.id);
  }, [searchQuery, cohorts, whatList, qalortUser]);

  const handleCohortClick = (cohort) => {
    navigate(`/cohort/messages/${cohort.slug}`);
    GetCohortAttendees(cohort.id);
  };

  const scrollToBottom = () => {
    // messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const resizeWatcher = () => {
      if (window.innerWidth < 1024) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };
    window.addEventListener("resize", resizeWatcher);
    return () => {
      window.removeEventListener("resize", resizeWatcher);
    };
  }, []);

  return (
    <>
      {collapsed ? (
        <Dropdown
          overlay={
            <Menu
              style={{ overflow: "auto", minWidth: 150 }}
              items={[
                {
                  key: "1",
                  label: (
                    <button
                      onClick={() => setWhatList("Created")}
                      className="pointer text-[#535393] text-[12px] !hover:bg-[#EFEFFE] !rounded-[12px] h-[20px] w-full text-left"
                    >
                      Created
                    </button>
                  ),
                },
                {
                  key: "2",
                  label: (
                    <button
                      onClick={() => setWhatList("Joined")}
                      className="pointer text-[#535393] text-[12px] !hover:bg-[#EFEFFE] !rounded-[12px] h-[20px] w-full text-left"
                    >
                      Joined
                    </button>
                  ),
                },
              ]}
            />
          }
          placement="bottomRight"
        >
          <img src={cDropdown} alt="" className="mx-auto mt-4 cursor-pointer" />
        </Dropdown>
      ) : (
        <div className="grid grid-cols-2">
          {qalortUser?.user_type === "instructor" &&
            ["Created", "Joined"].map((item, index) => (
              <button
                key={index}
                onClick={() => setWhatList(item)}
                className={clsx(
                  "h-[56px] border-0 border-b text-[#535393] border-[#ECEBF5]  flex items-center justify-center font-bold",
                  {
                    "border-b-2 border-pri pri": whatList === item,
                  }
                )}
              >
                {item}
              </button>
            ))}
        </div>
      )}

      <div
        className={clsx("flex p-4 gap-2", {
          "px-2": collapsed,
        })}
      >
        <button
          onClick={() => {
            if (collapsed) {
              setOpenSearchModal(true);
            }
          }}
          className="flex items-center w-[80%] relative"
        >
          <img src={search} alt="" className="absolute left-3" />
          <input
            type="text"
            placeholder="Search"
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-8 w-full border border-[#ECEBF5] rounded-[6px] px-2 h-[30px] focus:outline-none"
          />
        </button>
        {!collapsed && (
          <div>
            <CohortTimeFilter />
          </div>
        )}
      </div>

      <div
        className={clsx("flex-1 w-full h-[calc(100vh-345px)] overflow-y-auto", {
          "px-4": !collapsed,
          "px-2": collapsed,
        })}
      >
        {filteredCohorts.map((cohort, index) => (
          <button
            className={clsx(
              "flex items-center p-2 mb-2 w-full border border-transparent",
              {
                "bg-[#F9F9FF] border-pri rounded-[8px] shadow-md shadow-blue-500/10":
                  cohort.slug === slug,
              }
            )}
            key={index}
            onClick={() => handleCohortClick(cohort)}
          >
            <div>
              <div className="w-[28px] h-[28px] text-[12px] text-[#30307D] font-semibold bg-[#EFEFFE] rounded-[6px] flex items-center justify-center uppercase">
                {getInitials(cohort?.title)}
              </div>
            </div>
            <p
              className={clsx(
                "mb-0 pl-2 one-liner font-medium text-[12px] text-[#202053] one-liner",
                {
                  hidden: collapsed,
                }
              )}
            >
              {cohort?.title}
            </p>
          </button>
        ))}
      </div>

      {qalortUser?.user_type === "instructor" && (
        <div
          className={clsx(
            "absolute bottom-0 w-full border-t border-[#ECEBF5] px-4 py-4 z-40 bg-white",
            {
              "!px-2": !collapsed,
            }
          )}
        >
          <Link to={"/cohort/create-cohort"}>
            <QalortButton type="primary" className="w-full">
              + {collapsed ? "" : "New Cohort"}
            </QalortButton>
          </Link>
        </div>
      )}

      <SearchCohortsModal
        open={openSearchModal}
        onClose={() => setOpenSearchModal(false)}
      />
    </>
  );
};

export default CohortList;
